<panel width="400">
  <h1>{{ 'invoice.create-objection.header' | translate }}</h1>
  @if (loading) {
    <skeletons [defaultSkeletons]="5" />
  }
  @if (!loading) {
    <section>
      <reason-select [label]="'invoice.create-objection.reason' | translate" [(reasonId)]="objection.reasonId" [type]="reasonType.Objection" [required]="true" />
      <custom-input [label]="'invoice.create-objection.comment' | translate" [inputType]="inputType.Textarea" [(value)]="objection.comment" [required]="false" />
      <date-input [label]="'invoice.create-objection.registered-date' | translate" [(value)]="objection.registeredDate" [required]="true" [maxDate]="today" />
    </section>
  }
  <section>
    <button (click)="createOrUpdate()" [label]="'general.save' | translate"></button>
  </section>
</panel>
